import { createSelector } from '@reduxjs/toolkit';

import { createMappingByKey } from '@paragon/production-app-utilities';

import { RootState } from '../slices';

export const getProductionComponentInstancesByProductionGroupGuid = createSelector(
  (state: RootState) => state.productionGroups,
  (state: RootState) => state.productionComponentInstances,

  (productionGroups, productionComponentInstances) =>
    createMappingByKey(
      productionComponentInstances,
      (productionComponentInstance) => productionComponentInstance.productionGroupGuid,
      productionGroups,
    ),
);
